<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">{{ $t('campusAttendance.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <form class="form-horizontal">
        <div class="row">
          <div class="col-sm-12">
            <div class="row form-group m-b-15">
              <label class="col-md-3 col-form-label required">{{
                $t('campusAttendance.attendaceDate')
              }}</label>
              <div class="col-md-8">
                <ts-date-picker-input
                  v-model="editData.datescan"
                  :closeOnSelect="true"
                  readonly
                >
                </ts-date-picker-input>
                <div class="validate" v-if="errors.has('datescan')">
                  {{ errors.first('datescan') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="row form-group m-b-15">
              <label class="col-md-3 col-form-label required">{{
                $t('campusAttendance.studentName')
              }}</label>
              <div class="col-md-8">
                <input
                  :value="editData.student_name"
                  class="form-control"
                  readonly
                />
                <div class="validate" v-if="errors.has('student_id')">
                  {{ errors.first('student_id') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="row form-group m-b-15">
              <label class="col-md-3 col-form-label required">{{
                $t('campusAttendance.checkIn')
              }}</label>
              <div class="col-md-8">
                <div class="row">
                  <div class="col-sm-4">
                    <a-time-picker
                      format="HH:mm"
                      @change="onChangeCheckIn"
                      :default-value="moment(this.model.check_in, 'HH:mm')"
                      :disabled="editData.scan_status == 'Auto'"
                    />
                    <div class="validate" v-if="errors.has('check_in')">
                      {{ errors.first('check_in') }}
                    </div>
                  </div>

                  <div class="col-sm-8">
                    <div class="row">
                      <label class="col-md-5 col-form-label">{{
                        $t('campusAttendance.checkOut')
                      }}</label>
                      <div class="col-md-7">
                        <a-time-picker
                          @change="onChangeCheckOut"
                          format="HH:mm"
                          :default-value="
                            this.model.check_out
                              ? moment(this.model.check_out, 'HH:mm')
                              : null
                          "
                        />
                        <div class="validate" v-if="errors.has('check_out')">
                          {{ errors.first('check_out') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="row form-group m-b-15">
              <label class="col-md-3 col-form-label required">{{
                $t('campusAttendance.remarks')
              }}</label>
              <div class="col-md-8">
                <textarea
                  v-model="model.att_description"
                  class="form-control"
                  rows="5"
                ></textarea>
                <div class="validate" v-if="errors.has('att_description')">
                  {{ errors.first('att_description') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 text-right">
            <ts-button
              class="btn-default mr-2"
              @click.prevent="$emit('close')"
              >{{ $t('cancel') }}</ts-button
            >
            <ts-button
              class="btn-primary ml-2"
              @click.prevent="update"
              :waiting="saving"
              >{{ $t('update') }}</ts-button
            >
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  props: ['editData'],
  name: 'editCampusAttendance',
  data() {
    return {
      model: {
        datescan: moment().format('DD-MM-YYYY'),
        student_id: null,
        check_in: null,
        check_out: null,
        att_description: null
      },
      errors: new Errors(),
      saving: false
    }
  },
  created() {
    this.setEditData()
  },
  methods: {
    moment,
    onChangeCheckIn(moment, check_in) {
      this.model.check_in = check_in
    },
    onChangeCheckOut(moment, check_out) {
      this.model.check_out = check_out
    },
    setEditData() {
      this.model.student_id = this.editData.student_id
      this.model.datescan = this.editData.datescan
      this.model.check_in = this.editData.t1
      this.model.check_out = this.editData.t2
      this.model.att_description = this.editData.att_description
    },
    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('campusAttendance/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.saving = false
          this.$emit('close')
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    }
  }
}
</script>
